import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { EmailCampaignService, GetCampaignOptions } from '../../shared/services/email-campaign.service';
import { CampaignSummary, campaignIsEditable } from '../../shared/models/email-campaign.model';
import { DialogService } from '../../shared/services/dialog.service';

const campaignPageSize = 25;

@Component({
  selector: 'app-user-mgmt-campaigns',
  templateUrl: './campaigns.component.html',
  styleUrls: ['./campaigns.component.scss']
})
export class CampaignsComponent implements OnInit, OnDestroy {

  loadingCampaigns = false;
  searchFilterFocused = false;
  campaigns: CampaignSummary[] = [];
  totalCampaigns = 0;
  currentCampaignsPage = 1;
  searchString = '';
  statusFilter = '';
  selectedCampaignId: string = null;

  private _subscriptions: Subscription[] = [];

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
    public _campaignService: EmailCampaignService,
    private _dialogService: DialogService,
  ) { }

  ngOnInit(): void {
    this.loadCampaigns();
  }

  ngOnDestroy(): void {
    this._subscriptions.forEach((s) => s.unsubscribe());
    this._subscriptions = [];
  }

  get campaignsNumberOfPages(): number {
    return Math.ceil(this.totalCampaigns / campaignPageSize);
  }

  loadCampaigns() {
    this.loadingCampaigns = true;
    let params: GetCampaignOptions = {
      limit: campaignPageSize,
      offset: (this.currentCampaignsPage - 1) * campaignPageSize,
      page: this.currentCampaignsPage,
    };
    if (this.searchString) {
      params.search = this.searchString;
    }
    if (this.statusFilter) {
      params.status = this.statusFilter;
    }
    this._campaignService.getAllCampaigns(params).subscribe((res) => {
      this.loadingCampaigns = false;
      this.totalCampaigns = res.count;
      this.campaigns = res.results;
    }, (error) => {
      this.loadingCampaigns = false;
      console.log(error);
    });
  }

  submitSearch() {
    this.searchFilterFocused = false;
    this.currentCampaignsPage = 1;
    this.loadCampaigns();
  }

  setPage(page: number) {
    if (!isNaN(page) && page !== this.currentCampaignsPage) {
      this.currentCampaignsPage = page;
      this.loadCampaigns();
    }
  }

  viewCampaign(campaign: CampaignSummary) {
    if (campaignIsEditable(campaign.status)) {
      this.openCampaignEditor(campaign.campaign_id);
      return;
    }
    this.selectedCampaignId = campaign.campaign_id;
  }

  editCampaign(campaignId: string) {
    this.selectedCampaignId = null;
    this.openCampaignEditor(campaignId);
  }

  openCampaignEditor(campaignId: string) {
    this._dialogService.displayCampaignSendDialog({ campaignId: campaignId }).subscribe((changed) => {
      if (changed) {
        this.loadCampaigns();
      }
    });
  }

  closeDetail() {
    this.selectedCampaignId = null;
    this.loadCampaigns();
  }

  campaignTrackBy(i: number, campaign: CampaignSummary) {
    return campaign.campaign_id;
  }

  displayNewCampaignDialog() {
    this._dialogService.displayCampaignSendDialog({}).subscribe((changed) => {
      if (changed) {
        this.loadCampaigns();
      }
    });
  }
}
